type FlagFeedbackBannerProps = {
  comment?: string | null;
};

/** Shows the user's flag feedback below the question stem. */
export function FlagFeedbackBanner({ comment }: FlagFeedbackBannerProps) {
  const text = comment?.trim();
  if (!text) return null;

  return (
    <div
      className="flagged-feedback"
      style={{
        margin: "16px 0 20px",
        padding: "12px 14px",
        borderRadius: 6,
        background: "#fff5f5",
        border: "1px solid #f1aeb5",
        color: "#842029",
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4, fontSize: 13 }}>
        Your feedback
      </div>
      <div style={{ whiteSpace: "pre-wrap", fontSize: 14, lineHeight: 1.45 }}>
        {text}
      </div>
    </div>
  );
}
